import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import BaseService from "../BaseService";

class RfpWatchlistService extends BaseService {

    static url = "rfp_watchlists";
    static apis = {
        getList: this.url + "/count"
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("rfp_watchlists");
    }

    getList(customerId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: RfpWatchlistService.apis.getList, method: "GET", params: { customer_id: customerId }, authorization: true, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    deleteRecord(customerId, kitId) {
        var that = this
        var data = {
            customer_id: customerId,
            rfp_id: kitId
        }

        return new Promise((resolve, reject) => {
            that.axios({
                url: RfpWatchlistService.url, method: "DELETE", data: data, authorization: true, showLoader: true,
                message: {success: GeneralHelper.buildMessage(1, "Removed from watchlist !")}
            })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default RfpWatchlistService;